// extracted by mini-css-extract-plugin
export default {"root":"Label_root__Ix-p7","asterix":"Label_asterix__nIAOt"};